import { VALIDATION_RULES, MESSAGES } from '../constants/bankAccountsConstants';
import { getCbuValidationError, normalizeCbu } from '../../../utils/cbuUtils';

export const filterBankAccounts = (accounts = [], searchTerm = '') => {
  if (!searchTerm) return accounts;

  const normalized = searchTerm.trim().toLowerCase();

  return accounts.filter((account) => {
    const bank = account.bank_name?.toLowerCase() || '';
    const number = account.account_number?.toLowerCase() || '';
    const alias = account.alias?.toLowerCase() || '';
    const cbu = account.cbu?.toLowerCase() || '';

    return (
      bank.includes(normalized) ||
      number.includes(normalized) ||
      alias.includes(normalized) ||
      cbu.includes(normalized)
    );
  });
};

export const validateBankAccount = (formData) => {
  const errors = {};

  VALIDATION_RULES.REQUIRED_FIELDS.forEach((field) => {
    if (!formData[field] || `${formData[field]}`.trim() === '') {
      errors[field] = MESSAGES.ERROR.REQUIRED_FIELD;
    }
  });

  const normalizedCbu = normalizeCbu(formData.cbu);
  if (normalizedCbu) {
    const cbuValidationError = getCbuValidationError(normalizedCbu);
    if (cbuValidationError) {
      errors.cbu = cbuValidationError;
    }
  }

  if (
    formData.account_number &&
    formData.account_number.trim().length === 0
  ) {
    errors.account_number = MESSAGES.ERROR.INVALID_ACCOUNT_NUMBER;
  }

  if (
    formData.alias &&
    formData.alias.length > VALIDATION_RULES.ALIAS_MAX_LENGTH
  ) {
    errors.alias = `Máximo ${VALIDATION_RULES.ALIAS_MAX_LENGTH} caracteres`;
  }

  return errors;
};
